module.exports = __webpack_public_path__ + "static/media/sistema-certificado.d270f3f5.png";